Hop.defineModule('dropdown-checkboxes', (root) => {
    const $checkboxes = root.querySelectorAll('[type="checkbox"]');
    const $dataCount = root.querySelector('[data-count]');
    const state = {};

    function isCheckbox(node) {
        const tagName = (node.tagName || '').toLowerCase();
        return tagName === 'input' && node.getAttribute('type') === 'checkbox';
    }

    function countActiveCheckboxes() {
        return Array.from($checkboxes).reduce((acc, node) => acc + (node.checked ? 1 : 0), 0);
    }

    function refresh() {
        if ($dataCount) {
            $dataCount.textContent = `(${countActiveCheckboxes()})`;
        }
    }

    function handleStateChange($checkbox) {
        const name = $checkbox.getAttribute('name');
        if (!state[name]) {
            state[name] = [];
        }

        const checked = $checkbox.checked;
        const value = $checkbox.value;
        if (checked) {
            state[name].push(value);
        } else {
            state[name].splice(state[name].indexOf(value), 1);
        }
    }

    function triggerChange() {
        root.dispatchEvent(
            new CustomEvent('dropdown:change', {
                bubbles: true,
                detail: state,
            }),
        );
    }

    function onChange(e) {
        const target = e.target;
        if (!isCheckbox(target)) {
            return;
        }

        handleStateChange(target);
        refresh();
        triggerChange();
    }

    function initializeState() {
        $checkboxes.forEach(($checkbox) => handleStateChange($checkbox));
    }

    function listenToEvents() {
        root.addEventListener('change', onChange);
    }

    function init() {
        listenToEvents();
        refresh();
        initializeState();
    }

    init();

    return function destroy() {
        root.removeEventListener('change', onChange);
    };
});
